<script setup>
import { computed } from 'vue'
import { state } from '@/components/Ajuda/Montador/composables/useBuilderState'

const scaleHint = computed(() => `${state.scale.toFixed(0)} px ≈ 1 m`)
</script>

<template>
  <div class="section">
    <label class="label">Escala (px por metro)</label>
    <input type="range" min="8" max="40" v-model.number="state.scale" />
    <div class="hint">{{ scaleHint }}</div>
  </div>
</template>

<style scoped>
.label { margin: 0 0 6px; font-size: 13px; color: #9eb3ff; }
</style>
